const OPEN_VALUE = '1';
const BUBBLE_Y_KEY = 'lesson-map-bubble-y';

export function readLessonMapPanelOpen(key: string | undefined): boolean {
  if (!key) return false;
  try {
    return localStorage.getItem(key) === OPEN_VALUE;
  } catch {
    return false;
  }
}

export function writeLessonMapPanelOpen(key: string | undefined, open: boolean): void {
  if (!key) return;
  try {
    if (open) {
      localStorage.setItem(key, OPEN_VALUE);
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function readLessonMapBubbleY(): number | null {
  try {
    const raw = localStorage.getItem(BUBBLE_Y_KEY);
    if (raw == null) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function writeLessonMapBubbleY(y: number): void {
  try {
    localStorage.setItem(BUBBLE_Y_KEY, String(Math.round(y)));
  } catch {
    /* ignore */
  }
}

export function clampLessonMapBubbleY(y: number, bubbleSizePx = 40): number {
  if (typeof window === 'undefined') return y;
  const margin = 12;
  const topBound = 64 + margin + bubbleSizePx / 2;
  const bottomBound = window.innerHeight - margin - bubbleSizePx / 2;
  return Math.min(bottomBound, Math.max(topBound, y));
}

export function defaultLessonMapBubbleY(): number {
  if (typeof window === 'undefined') return 400;
  return clampLessonMapBubbleY(window.innerHeight / 2);
}